module.exports = __webpack_public_path__ + "img/logo.c04035fe.png";